import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { userReducer } from './user/user.reducer';
import { cartReducer } from './cart/cart.reducer';
import { navigationReducer } from './navigation/navigation.reducer';
import { availableOffersReducer } from './available-offers/available-offers.reducer';
import { locationReducer } from './location/location.reducer';
import { UserEffects } from './user/user.effects';
import { CartEffects } from './cart/cart.effects';
import { AvailableOffersEffects } from './available-offers/available-offers.effects';
import { LocationEffects } from './location/location.effects';

export const storeConfig = provideStore({
  user: userReducer,
  cart: cartReducer,
  navigation: navigationReducer,
  availableOffers: availableOffersReducer,
  location: locationReducer,
});

export const effectsConfig = provideEffects([UserEffects, CartEffects, AvailableOffersEffects, LocationEffects]);
